import RRuleDomainService from "../RRule/RRule.service";
const DAY_UNIT = { label: "days", numDays: 1 };
const WEEK_UNIT = { label: "weeks", numDays: 7 };
const YEAR_UNIT = { label: "years", numDays: 365 };
const MONTH_UNIT = { label: "months", numDays: 1 };
export const AUTOMATED_SCHEDULE_UNITS = [
    DAY_UNIT,
    WEEK_UNIT,
    MONTH_UNIT,
    YEAR_UNIT,
];
const ScheduleTypes = {
    IntervalAutomatedSchedule: 1,
    RRuleAutomatedSchedule: 2,
};
export default class AutomatedScheduleDomainService {
    static getUnit(schedule) {
        if (!schedule || schedule.interval === 0) {
            return DAY_UNIT;
        }
        return (AUTOMATED_SCHEDULE_UNITS.find((u) => schedule.interval % u.numDays === 0) || DAY_UNIT);
    }
    static get ScheduleType() {
        return ScheduleTypes;
    }
    static fromJSON(json) {
        const schedule = Object.assign(Object.assign({}, json), { nextExecutionDate: json.nextExecutionDate && new Date(json.nextExecutionDate), lastExecutionDate: json.lastExecutionDate && new Date(json.lastExecutionDate), endDate: json.endDate && new Date(json.endDate), startDate: json.startDate && new Date(json.startDate) });
        switch (json.scheduleType) {
            case AutomatedScheduleDomainService.ScheduleType
                .IntervalAutomatedSchedule:
                return schedule;
            case AutomatedScheduleDomainService.ScheduleType.RRuleAutomatedSchedule:
                return Object.assign(Object.assign({}, schedule), { rrule: RRuleDomainService.fromString(json.rrule) });
            default:
                return schedule;
        }
    }
    static get BlankRRuleSchedule() {
        return {
            scheduleType: AutomatedScheduleDomainService.ScheduleType.RRuleAutomatedSchedule,
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'RRule'.
            rrule: "",
            nextExecutionDate: new Date(),
            lastExecutionDate: new Date(),
            endDate: new Date(),
            startDate: new Date(),
        };
    }
    static getOneTimeRRuleSchedule(date) {
        if (!date) {
            return null;
        }
        return {
            scheduleType: AutomatedScheduleDomainService.ScheduleType.RRuleAutomatedSchedule,
            rrule: RRuleDomainService.getOneTimeRRule(),
            startDate: date,
            nextExecutionDate: date,
            endDate: date,
            lastExecutionDate: date,
        };
    }
    static getValueInUnits(schedule, unit = AutomatedScheduleDomainService.getUnit(schedule)) {
        if (!schedule || schedule.interval === 0) {
            return 0;
        }
        return schedule.interval / unit.numDays;
    }
}
